import { Form, Spinner } from 'react-bootstrap'
import { emptyGuid } from '../../../utils/emptyGuid'
import React, { useCallback, useEffect, useState } from 'react'
import apiClient from '../../../utils/api/apiClient'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import { useTranslation } from 'react-i18next'
import ArraySelect from '../../Select/ArraySelect'
import MandatoryField from '../../MandatoryField/MandatoryField'
import ArticleSelect from '../Form/ArticleSelect'
import WarehousesSelect from '../Form/WarehousesSelect'
import { makeCall } from '../../../utils/api/makeCall'

const InventoryListByArticleStatistics = ({
  formData,
  setFormData,
  formErrors,
}) => {
  const { t } = useTranslation()
  const [isCurrentStock, setIsCurrentStock] = useState(true)
  const [priceLists, setPriceLists] = useState([])
  const [currencies, setCurrencies] = useState([])
  const [errorStates, setErrorStates] = useState({})
  const [loadingStates, setLoadingStates] = useState({})
  const [showToTalRowOnly, setShowToTalRowOnly] = useState(false)

  const updateCheckboxAndRadioProperty = (event, name) => {
    switch (name) {
      case 'currentStock':
        setIsCurrentStock(true)
        setFormData((prev) => ({
          ...prev,
          aVG_Methode: 'AVG_CurrentStock',
        }))
        break
      case 'receipts':
        setIsCurrentStock(false)
        setFormData((prev) => ({
          ...prev,
          aVG_Methode: 'AVG_Receipts',
        }))
        break
      case 'showToTalRowOnly':
        setShowToTalRowOnly(event.target.checked)
        setFormData((prev) => ({
          ...prev,
          showToTalRowOnly: event.target.checked,
        }))
        break
      default:
    }
  }
  const loadCurrencies = useCallback(async () => {
    makeCall(
      'loadCurrencies',
      async () => {
        let loadedCurrencies = await apiClient.getJson(APIEndpoints.currencies)
        setCurrencies(loadedCurrencies)
      },
      setErrorStates,
      setLoadingStates
    )
  }, [])
  const loadPriceLists = useCallback(async () => {
    makeCall(
      'loadPriceLists',
      async () => {
        let loadedPriceLists = await apiClient.getJson(APIEndpoints.priceLists)
        setPriceLists(loadedPriceLists)
      },
      setErrorStates,
      setLoadingStates
    )
  }, [])
  useEffect(() => {
    loadCurrencies()
    loadPriceLists()
  }, [loadCurrencies, loadPriceLists])

  if (errorStates.loadCurrencies)
    console.log('loadCurrencies errorStates:', errorStates.loadCurrencies)
  if (errorStates.loadPriceLists)
    console.log('loadPriceLists errorStates:', errorStates.loadPriceLists)
  return (
    <div>
      {loadingStates.loadPriceLists ? (
        <div className='d-flex align-items-center justify-content-center'>
          <Spinner animation='border' variant='primary' />
        </div>
      ) : (
        <>
          <Form.Group className='mb-3'>
            <Form.Label className='d-block ps-1'>{`${t(
              'reportConfig:pricelist'
            )}${'*'}`}</Form.Label>
            <ArraySelect
              value={formData.pricelistID}
              defaultOption={{ value: emptyGuid, name: t('pleaseSelect') }}
              defaultOptionIsSelectable
              options={priceLists}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  pricelistID: e.target.value,
                }))
              }
              returnEvent
              isInvalid={formErrors && formErrors.pricelistID}
            />
            <Form.Control.Feedback type='invalid'>
              {formErrors && formErrors.pricelistID}
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}
      {loadingStates.loadCurrencies ? (
        <div className='d-flex align-items-center justify-content-center'>
          <Spinner animation='border' variant='primary' />
        </div>
      ) : (
        <>
          <Form.Group className='mb-3'>
            <Form.Label className='d-block ps-1'>{`${t(
              'reportConfig:currency'
            )}${'*'}`}</Form.Label>
            <ArraySelect
              value={formData.currencyID}
              defaultOption={{ value: emptyGuid, name: t('pleaseSelect') }}
              defaultOptionIsSelectable
              options={currencies}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  currencyID: e.target.value,
                }))
              }
              returnEvent
              isInvalid={formErrors && formErrors.currencyID}
            />
            <Form.Control.Feedback type='invalid'>
              {formErrors && formErrors.currencyID}
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}
      <Form.Group className='mb-3'>
        <Form.Label className='d-block ps-1'>{`${t(
          'reportConfig:warehouseSelection'
        )}${'*'}`}</Form.Label>
        <WarehousesSelect
          name='createReportFor_StorehouseIDs'
          value={formData.createReportFor_StorehouseIDs}
          setFormData={setFormData}
        />
      </Form.Group>
      <Form.Group className='mb-3'>
        <Form.Label className='d-block ps-1'>
          {`${t('reportConfig:articleSelection')}`}
        </Form.Label>
        <ArticleSelect
          name='articleIDs'
          value={formData.articleIDs}
          setFormData={setFormData}
        />
      </Form.Group>
      <Form.Group className='mb-3'>
        <Form.Label className='ps-1'>
          {t('reportConfig:inventoryList_AVG_Methode')}
        </Form.Label>
        <Form.Check
          type='radio'
          id='receipts'
          name='createSheet'
          label={t('reportConfig:inventoryList_AVG_Receipts')}
          checked={!isCurrentStock}
          onChange={(e) => updateCheckboxAndRadioProperty(e, 'receipts')}
        />
        <Form.Check
          type='radio'
          id='currentStock'
          name='createSheet'
          label={t('reportConfig:inventoryList_AVG_CurrentStock')}
          checked={isCurrentStock}
          onChange={(e) => updateCheckboxAndRadioProperty(e, 'currentStock')}
        />
      </Form.Group>
      <Form.Group className='mb-3'>
        <Form.Label className='ps-1'>
          {t('reportConfig:inventoryList_Output')}
        </Form.Label>
        <Form.Check
          id='showToTalRowOnly'
          label={t('reportConfig:inventoryList_ShowToTalRowOnly')}
          type='checkbox'
          name='showToTalRowOnly'
          onChange={(e) =>
            updateCheckboxAndRadioProperty(e, 'showToTalRowOnly')
          }
          checked={showToTalRowOnly}
          isInvalid={formErrors && formErrors.showToTalRowOnly}
        />
      </Form.Group>
      <Form.Group className='mb-3'>
        <Form.Label className='ps-1'>
          {t(`reportConfig:emailAddress`)}
        </Form.Label>
        <Form.Control
          name='emailAddress'
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              emailAddress: e.target.value,
            }))
          }
          value={formData.emailAddress || ''}
          isInvalid={formErrors && formErrors.emailAddress}
          autoComplete='email'
        />
        <Form.Control.Feedback type='invalid'>
          {formErrors && formErrors.emailAddress}
        </Form.Control.Feedback>
      </Form.Group>
      <MandatoryField />
    </div>
  )
}
export default InventoryListByArticleStatistics
